import { FIELD_TYPES } from "constants/template-field-type";
import { BELOW, SIDE } from "constants/button_additional_text_position";
import { signupButtonColorOptions } from "constants/color-picker-constants";

export default {
  buttonColor: {
    type: FIELD_TYPES.COLOR_PICKER,
    label: "Color",
    possibleColors: signupButtonColorOptions
  },
  useCtaText: {
    type: FIELD_TYPES.BOOLEAN,
    label: "Use override default CTA"
  },
  ctaText: {
    type: FIELD_TYPES.TEXT,
    label: "Override Default CTA",
    translatable: true
  },
  signupWithsolutionAppReferenceId: {
    type: FIELD_TYPES.TEXT,
    label: "Solution Id:",
    labelDescription: "Leave blank unless signup with solution needed - enter the solution's app reference id"
  },
  additionalText: {
    type: FIELD_TYPES.TEXT,
    label: "Additional text (monday markup supported)",
    translatable: true
  },
  additionalTextMaxWidth: {
    type: FIELD_TYPES.TEXT,
    label: "Additional text max width"
  },
  additionalTextPosition: {
    type: FIELD_TYPES.COMBO,
    options: [
      { value: SIDE, text: "Side" },
      { value: BELOW, text: "Below" }
    ],
    label: "Position of additional text",
    labelDescription: "mobile version will always be shown below"
  },
  buttonId: {
    type: FIELD_TYPES.TEXT,
    label: "Button ID",
    labelDescription: "board_kind in signup_main_cta_clicked BB event"
  },
  isMobileInputTransparent: {
    type: FIELD_TYPES.BOOLEAN,
    label: "Use mobile transparent input",
    labelDescription: "To be used in case of white button"
  },
  signupClusterId: {
    type: FIELD_TYPES.CLUSTERS,
    label: "Cluster",
    labelDescription: "Use only in generic pages if you want to assign a cluster"
  },
  showGoogleConnectOnMobile: {
    type: FIELD_TYPES.BOOLEAN,
    label: "Mobile google connect",
    labelDescription: "Display google connect option in mobile pages"
  }
};
